module.exports = __webpack_public_path__ + "static/img/3.7874ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR410A/3.jpg
// module id = lnIu
// module chunks = 1